// extracted by mini-css-extract-plugin
export default {"container":"navigation-header-search_container","searchContainer":"navigation-header-search_searchContainer","closeContainer":"navigation-header-search_closeContainer"};